export default {
    key: 'guided-tour',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: false,
    hideCrossSells: true,
    disablePassengers: false,
    activityId: undefined,
    categoryId: '204390dd-6eba-4368-87db-1a436c466a67',
    defaultDuration: undefined,
    isMultiDay: false,
    isUsingReductionCards: false,
    isUsingKeyCards: false,
    isUsingPromos: false,
    showDuration: true,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: undefined,
    isLocalListing: false,
    steps: [
        {
            routeName: 'offerFlow-guided-tour-steps-step-1-activity',
            name: 'offerFlow.pages.stepActivitySelection.name.common',
        },
        {
            routeName: 'offerFlow-guided-tour-steps-step-2-date',
            name: 'offerFlow.pages.stepDate.name.common',
        },
        {
            routeName: 'offerFlow-guided-tour-steps-step-3-options',
            name: 'offerFlow.pages.stepActivityOptions.name.common',
        },
        {
            routeName: 'offerFlow-guided-tour-steps-step-4-passengers',
            name: 'offerFlow.pages.stepPassengers.name.common',
            skipIfUpsell: true,
        },
    ],

} satisfies ProductConfigActivity;
